import { render, staticRenderFns } from "./editorial_placeholders.vue?vue&type=template&id=a9c545d4&scoped=true&lang=html"
import script from "./editorial_placeholders.vue?vue&type=script&lang=js"
export * from "./editorial_placeholders.vue?vue&type=script&lang=js"
import style0 from "./editorial_placeholders.vue?vue&type=style&index=0&id=a9c545d4&prod&lang=css"
import style1 from "./editorial_placeholders.vue?vue&type=style&index=1&id=a9c545d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c545d4",
  null
  
)

export default component.exports